import { ArrowRightLeft, Mail } from 'lucide-react';

import { numberFormat } from '../../pages/weeklyreport/format';
import { type weeklyReportTotals } from '../../services/api/weekly-report';
import { KpiCard } from '../dashboard/KpiCard';

interface HandoffStatsProps {
  handoff: weeklyReportTotals['handoff'];
  emailDraft: weeklyReportTotals['emailDraft'];
}

export const HandoffStats = ({ handoff, emailDraft }: HandoffStatsProps) => (
  <div className="grid grid-cols-2 gap-4 sm:grid-cols-3">
    <KpiCard
      label="Handoff till agent"
      value={numberFormat.format(handoff.total)}
      icon={<ArrowRightLeft className="h-6 w-6" />}
    />
    <KpiCard
      label="Draft-mejl skickade"
      value={numberFormat.format(emailDraft.sent)}
      icon={<Mail className="h-6 w-6" />}
    />
    <KpiCard
      label="Draft-mejl misslyckade"
      value={numberFormat.format(emailDraft.failed)}
      icon={<Mail className="h-6 w-6" />}
      tone={emailDraft.failed > 0 ? 'danger' : 'default'}
    />
  </div>
);
